
export enum Path {
  Maintenance = '/',
  Home= '/',
  Home2 = '/home',
  About = '/about',
  ContactUs = '/contact',
  Events = '/events',
  Admission = '/admission',




 

}
